(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("checkoutStep3Payment", {
        templateUrl: "app/checkout/checkoutStep3Payment.component.html",
        controller: ["checkoutService", "frameworkService", "messageService", "checkoutResource", "$state", "$translate", "_", CheckoutStep3PaymentCtrl],
        controllerAs: "vm"
    });
    function CheckoutStep3PaymentCtrl(checkoutService, frameworkService, messageService, checkoutResource, $state, $translate, _) {
        var vm = this;
        vm.loading = true;
        vm.lockPaymentButtons = {};
        vm.disable = false;
        vm.frameworkData = frameworkService.data;
        if (!checkoutService.wizard.isStep2Valid) {
            $state.go("main.checkout.step1", {}, { location: "replace" });
            return;
        }
        vm.model = checkoutService.model;
        checkoutService.setStep(3);
        loadShoppingCart();
        /////////////////////////////////////////////////////
        function loadShoppingCart() {
            checkoutResource.calculateTaxes(vm.model, function (result) {
                vm.model.details = result;
                vm.hasProductDiscount = vm.model.details.products.some(function (item) { return item.productDiscountAmount > 0; });
                _.each(vm.model.details.paymentMethods, function (item) { vm.lockPaymentButtons[item.id] = false; });
                vm.loading = false;
                if (result.totalAmount === 0)
                    vm.free = true;
            }, function (error) {
                messageService.error(error);
                $state.go("main.checkout.step2", {}, { location: "replace" });
            });
        }
        vm.pay = function (paymentMethodId) {
            vm.lockPaymentButtons[paymentMethodId] = true;
            vm.disable = true;
            checkoutService.model.error = false;
            checkoutService.model.selectedPaymentId = paymentMethodId;
            if (paymentMethodId === "MonerisCheckout" || paymentMethodId === "BamboraCheckout" || paymentMethodId === "AffiniPayHostedPage") {
                if (paymentMethodId === "MonerisCheckout" || paymentMethodId === "BamboraCheckout")
                    checkoutService.save();
                checkoutService.wizard.isStep3Valid = true;
                $state.go("main.checkout.step4", {}, { location: "replace" });
            }
            else if (paymentMethodId === "BamboraCustomCheckout") {
                checkoutService.save();
                checkoutService.wizard.isStep3Valid = true;
                $state.go("main.checkout.step4", { creditCardInfo: "custom" }, { location: "replace" });
            }
            else if (paymentMethodId === "StripeCheckout") {
                checkoutService.save();
                checkoutService.wizard.isStep3Valid = true;
                $state.go("main.checkout.step4", {}, { location: "replace" });
            }
            else if (paymentMethodId === "PurchaseOrder") {
                checkoutService.save();
                checkoutService.wizard.isStep3Valid = true;
                $state.go("main.checkout.step4", { purchaseOrder: true }, { location: "replace" });
            }
            else if (paymentMethodId === "Invoice") {
                checkoutService.save();
                checkoutService.wizard.isStep3Valid = true;
                $state.go("main.checkout.step4", {}, { location: "replace" });
            }
            else {
                var customMultipleItemsDescription = $translate.instant("storefront.checkout.customMultipleItemsDescription", { tenantName: frameworkService.data.tenant.url.toUpperCase() });
                checkoutResource.pay({ paymentMethodId: paymentMethodId, orderGuid: vm.model.details.orderGuid, customMultipleItemsDescription: customMultipleItemsDescription }, function (result) {
                    switch (result.type) {
                        case "REDIRECT":
                            checkoutService.save();
                            window.open(result.redirectUrl, result.redirectTarget);
                            break;
                        case "SUCCESS":
                            vm.lockPaymentButtons[paymentMethodId] = false;
                            vm.disable = false;
                            checkoutService.wizard.isStep3Valid = true;
                            $state.go("main.checkout.step4", {}, { location: "replace" });
                            break;
                        case "FAILURE":
                            messageService.error(result.errorMessage);
                            vm.lockPaymentButtons[paymentMethodId] = false;
                            vm.disable = false;
                            break;
                    }
                }, function (error) {
                    messageService.error(error);
                    vm.lockPaymentButtons[paymentMethodId] = false;
                    vm.disable = false;
                });
            }
        };
        vm.isPaymentMethodEnabled = function (paymentMethodId) {
            return _.some(vm.model.details.paymentMethods, {
                "id": paymentMethodId
            });
        };
    }
}());
